<header></header>
<div class="post-login-2">
  <div class="post-login-2-col-1 h-100">
    <left-panel activeTab="2" *ngIf="this.auth?.detailuser != undefined && this.AccountType == 'C'"></left-panel>
    <left-panel activeTab="3" *ngIf="this.auth?.detailuser != undefined  && this.AccountType == 'L'"></left-panel>
  </div>
  <div class="post-login-2-col-2 has-banner">
  </div>
  <div class="post-login-2-col-3 bg-base-100 p-mobile-15 h-100 pt-70-pb-70-pr-40">
    <div class="onboarding-canvas h-100">
      <grid-row class="justify-content-center align-content-between pb-30 h-100">
        <grid-col col="12">
          <grid-row class="mt-30 mt-mobile-0">
            <grid-col col="8">
              <div class="font-400 font-size-20px line-h-25">
                {{ "PleaseViewStatement" | translate }}
              </div>
            </grid-col>
          </grid-row>
            <div class="form-group mt-40">
              <label>{{"SelectMonth" | translate}}</label>
              <drop-down-list dropDownImage="false" dropDownSearch="false" [selectedValue]="this.selectedMonth"
                [dropDownData]="this.Monthlist" (itemselected)="onMonthChange($event)">
                {{this.selectedMonth}}
              </drop-down-list>
            </div>
        </grid-col>
        <grid-col col="12">
          <grid-row class="justify-content-between align-item-center mt-50">
            <grid-col col="2">
              <div class="mt-15">
                <button class="btn-back" (click)="back()">
                  <i class="icon-back"></i>
                </button>
              </div>
            </grid-col>
            <grid-col col="9">
              <button class="btn-dft" [disabled]="isValid()" [routerLink]="['/CardTransactionHistory']"
                [queryParams]="{ id:this.internalId,MonthYear:this.MonthYear,type:this.AccountType }">
                {{ "CONFIRM" | translate }}
              </button>
            </grid-col>
          </grid-row>
        </grid-col>
      </grid-row>
    </div>
  </div>
</div>